import { render, staticRenderFns } from "./ErrorDialog.vue?vue&type=template&id=c08b27f6&scoped=true"
import script from "./ErrorDialog.vue?vue&type=script&lang=js"
export * from "./ErrorDialog.vue?vue&type=script&lang=js"
import style0 from "./ErrorDialog.vue?vue&type=style&index=0&id=c08b27f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08b27f6",
  null
  
)

export default component.exports